import { css } from '@emotion/react';

import { SCROLL_UP } from '../../const';
import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export default () => {
  const {
    screenSizes,
    typography,
    breakpoints,
    spacing,
    colors,
    heights,
    fluidTypeScale,
  } = useTheme();

  return {
    hero: (
      { mobile, desktop },
      overlayVariation,
      scrollDirection,
      headerHeight,
      isRec,
      MQtoHideQuickLinks
    ) => {
      return css`
        display: grid;
        align-items: end;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        grid-template-rows: 70% 30%;
        align-items: center;
        background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 20%,
            rgba(1, 30, 65) ${isRec === 'true' ? '55%' : '75%'},
            rgba(1, 30, 65) 100%
          ),
          url(${mobile.src}) 75% 0 no-repeat;
        background-size: contain;
        height: 812px;
        margin-top: ${scrollDirection === SCROLL_UP
          ? 0
          : heights.mainNav.mobile};

        ${MQtoHideQuickLinks &&
        css`
          grid-template-rows: auto;
        `}
        @media (min-width: 654px) and (max-width: 769px) {
          background-size: cover;
          grid-template-rows: 130% 0% !important;
          align-items: center;
          background: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 20%,
              rgba(1, 30, 65) 75%,
              rgba(1, 30, 65) 100%
            ),
            url(${desktop.src}) 0 no-repeat;
          background-size: cover;
          margin-top: ${scrollDirection === SCROLL_UP ? 0 : headerHeight};
          background-position: 77% 0% !important;
        }

        ${breakpoints.m} {
          grid-template-rows: 60% 40%;
          align-items: center;
          background: linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0) 20%,
              rgba(1, 30, 65) 75%,
              rgba(1, 30, 65) 100%
            ),
            url(${desktop.src}) center 0 no-repeat;
          background-size: cover;
          margin-top: ${scrollDirection === SCROLL_UP ? 0 : headerHeight};

          &::before {
            top: 10vh;
            left: 0;
            width: 100%;
            height: 100vh;
            z-index: 1;
            outline: 0;

            ${breakpoints.l} {
              height: 700px;
              top: calc(100vh - 95vh);
            }
          }

          &::after {
            background: url(${publicPath(
                '/images/common/discover-football-watermark.svg'
              )})
              right center no-repeat;
          }
        }
      `;
    },
    textWrapper: hasLoaded => css`
      position: relative;
      z-index: 1;
      align-self: end;
      opacity: 0;
      transition: opacity 0.5s;
      width: 90vw;
      margin: 0 auto;
      margin: 0px auto calc(27vh);

      ${hasLoaded &&
      css`
        opacity: 1;
      `}

      &.fadeOut {
        opacity: 0.3;
      }

      ${breakpoints.m} {
        max-width: ${screenSizes.xl};
      }

      @media (min-device-width: 768px) and (max-device-width: 992px) {
        margin: 0 0 0 50px !important;
      }
      @media (min-width: 654px) and (max-width: 768px) {
        background-image: none !important;
      }
    `,
    mainText: isHomePage => css`
      ${typography.headings[3].mobile};
      font-style: normal;
      font-size: ${fluidTypeScale.font54_84};
      z-index: 2;
      position: relative;
      letter-spacing: 0.02em !important;
      color: ${colors.white};
      max-width: unset;
      transition: opacity 0.5s;
      text-align: center;
      margin: auto;

      ${isHomePage &&
      css`
        left: 0;
        text-align: left;
        margin: 0;
      `}

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 70px;
        left: Calc(100% - 61%);

        ${isHomePage &&
        css`
          left: 0;
        `}

        ${breakpoints.m} {
          left: Calc(100% - 53%);
        }
      }

      ${breakpoints.m} {
        ${typography.headings[1].desktop};
        max-width: 100%;
        font-size: ${fluidTypeScale.font54_84};
        font-style: normal;
        font-weight: 700;
        line-height: 84px;
        text-align: left;
      }

      ${breakpoints.l} {
        &::before {
          left: -8rem;
        }
      }
    `,
    quickLinks: css`
      max-width: 311px !important;
      position: absolute;
      margin: 600px;
      padding-left: 0px !important;
      padding-top: 0px !important;
      cursor: pointer;
      margin-top: 180px !important;
      border-radius: 8px;
      background-image: none !important;

      div.sticky {
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 0;
        background-color: green;
        border: 2px solid #4caf50;
      }

      ${breakpoints.m} {
        margin-left: calc(100% - 28%) !important;
        background-color: white;
        background-image: none !important;
        margin-top: 0 !important;

        div.sticky {
          position: -webkit-sticky; /* Safari */
          position: sticky;
          top: 0;
          background-color: green;
          border: 2px solid #4caf50;
        }
      }

      ${breakpoints.xl} {
        margin-left: calc(100% - 35%) !important;
        margin-top: 0 !important;
        background-image: none !important;
      }

      @media (min-device-width: 768px) and (max-device-width: 992px) {
        margin-left: calc(100% - 22%) !important;
      }
    `,
    quick: closeani => css`
      max-width: 311px !important;
      height: 0px;
      background-color: ${colors.white};
      border: 1px ${colors.lightGrey} solid;
      border-radius: 0 0 8px 8px !important;
      display: grid;
      opacity: 0;
      border-top: 0;

      ${breakpoints.xl} {
        border-radius: 0 0 8px 8px !important;
      }

      ${closeani === true &&
      css`
        height: 194px;
        animation-name: opacitytest;
        animation-duration: 1s;
        margin: auto;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;

        @keyframes opacitytest {
          50% {
            transition-property: opacity;
            transition: 0.5s;
            transition-timing-function: ease-in-out;

            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
      `}

      ${closeani === false &&
      css`
        transition-property: height;
        transition-duration: 0.1s;
        transition-timing-function: ease-in-out;
      `}
    `,
    sectionStyle: css`
      font-size: 18px;
      color: ${colors.navy};
    `,
    closeIcon: closeani => css`
      cursor: pointer;
      margin: auto;

      svg {
        color: red;
        width: 20px;
        height: 3px;
        margin: auto;
        position: relative;
        z-index: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow-y: hidden;

        ${closeani === true &&
        css`
          animation-name: closeicon;
          animation-duration: 0.7s;
          margin: auto;

          @keyframes closeicon {
            50% {
              transition-property: width;
              transition: 0.5s;
              transition-timing-function: ease-in-out;

              width: 5px;
            }
            100% {
              width: 20px;
            }
          }
        `}
      }
    `,
    listData: css`
      align-items: center;
      display: grid;
      grid-template-columns: 6% auto;
      grid-template-rows: 95% 5%;
      font-size: 18px;
      color: ${colors.navy};
      width: 263px;
      padding-left: 9px;
      height: 48px;

      &:hover {
        border: 0px;
        background-color: ${colors.lightGrey};
        border-radius: 10px;
      }
    `,
    quickAnimate: css`
      padding-left: 23px;
    `,
    redlineSVG: css`
      display: grid;
      grid-template-columns: 7% auto;
    `,
    svgStyle: css`
      margin-top: 5px;
    `,
    onThisPage: closeani => css`
      font-size: 20px;
      font-weight: 700;
      color: ${colors.navy};
      border: 1px ${colors.lightGrey} solid;
      border-bottom: 0 grey solid;
      background-color: white;
      display: grid;
      grid-template-columns: 65% 35%;
      grid-template-rows: 99% 1%;
      padding-left: 25px;
      height: 60px;
      border-radius: 8px !important;
      width: 311px;

      ${closeani === true &&
      css`
        border-radius: 8px 8px 0 0 !important;
      `}
    `,
    pageHeading: css`
      margin-bottom: 10px;
      padding-top: 18px;
    `,
    mainText1: isHomePage1 => css`
      ${typography.headings[3].mobile};
      z-index: 2;
      position: relative;
      font-size: ${fluidTypeScale.font54_84};
      color: ${colors.white};
      max-width: unset;
      transition: opacity 0.5s;
      letter-spacing: 0.02em !important;
      margin: auto;

      ${isHomePage1 &&
      css`
        max-width: 50%;
        left: 0;
        text-align: left;
        margin: 0;
      `}

      ${breakpoints.m} {
        ${typography.headings[1].desktop};
        max-width: 100%;
        font-size: ${fluidTypeScale.font54_84};
        letter-spacing: 0.02em !important;
        font-weight: 700;
        line-height: 84px;
        text-align: left;
      }

      ${breakpoints.l} {
        &::before {
          left: -8rem;
        }
      }
    `,
    mainTextNearme: css`
      width: 100%;
      max-width: 100% !important;
      position: relative;
      padding-left: 0px !important;
      padding-top: 0px !important;
      background-image: none !important;
    `,
    redline: css`
      position: absolute;
      left: 8px;
      bottom: 0px;
      width: 170px;
      border-bottom: 6px solid ${colors.red_CB0A00};
      border-color: ${colors.red_CB0A00};

      ${breakpoints.m} {
        left: 8px;
        bottom: 6px;
        width: 245px;
      }
      @media screen and (min-width: 1024px) {
        left: 8px;
        bottom: 3px;
        width: 245px;
      }
    `,
    orangeline: css`
      position: absolute;
      left: 8px;
      bottom: -6px;
      width: 170px;
      border-bottom: 6px solid ${colors.red_FF0D00};
      border-color: ${colors.red_FF0D00};

      ${breakpoints.m} {
        left: 8px;
        bottom: 0px;
        width: 245px;
      }
      @media screen and (min-width: 1024px) {
        left: 8px;
        bottom: -3px;
        width: 245px;
      }
    `,
    secondaryText: css`
      font-size: ${fluidTypeScale.font18_20};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.0027em;
      text-align: justify;
      color: ${colors.greyShade_eceef3};
      margin-top: 1.8rem;
      width: 311px;

      ${breakpoints.m} {
        margin-top: ${spacing.s};
        padding: 0.2rem 0 ${spacing.m} 0;
        font-size: ${fluidTypeScale.font18_20};
        font-weight: 400;
        line-height: 28px;
        text-align: left;
        width: 394px;
        height: 56px;
      }
    `,
    cta: css`
      background-color: ${colors.buttonRed};
      color: ${colors.white};
      text-transform: uppercase;
      margin-top: 1.5rem;
      border: 3px solid transparent;
      font-size: ${fluidTypeScale.font16_16};
      cursor: pointer;
      width: 311px;

      ${breakpoints.m} {
        width: 394px;
      }
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        color: ${colors.black};
        border: 2px solid ${colors.border_black};
        outline: none;
        text-decoration: underline;
        text-decoration-color: ${colors.black};
      }
      &:hover {
        border-radius: 0rem;
        background-color: ${colors.white} !important;
        color: #16161e !important;
      }
    `,
    secondaryText1: css`
      font-size: ${fluidTypeScale.font21_20};
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0.0011em;
      text-align: left;
      color: ${colors.greyShade_eceef3};
      height: 48px;
      padding-top: 35px;
      width: 311px;

      ${breakpoints.m} {
        font-size: ${fluidTypeScale.font21_20};
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0.003em;
        text-align: left;
        color: white;
        width: 468px;
        height: 28px;
      }
    `,
    secondaryText2: css`
      font-size: ${fluidTypeScale.font20_18};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.0027em;
      text-align: left;
      color: ${colors.greyShade_eceef3};
      padding-top: 40px;

      ${breakpoints.m} {
        padding-top: 30px;
        font-size: ${fluidTypeScale.font20_18};
        font-weight: 400;
        line-height: 28px;
        text-align: left;
        color: ${colors.greyShade_eceef3};
        width: 394px;
      }
    `,
    cta1: css`
      background: transparent;
      background-color: none;
      color: ${colors.white};
      text-transform: uppercase;
      margin-top: 1.5rem;
      border: 2px solid ${colors.color_aebde6};
      font-size: ${fluidTypeScale.font16_16};
      max-width: 394px;
      height: 48px;
      text-align: center;
      border-radius: 0.25rem;
      padding: 10px;
      margin-bottom: 30px;
      cursor: pointer;
      width: 311px;
      &:hover {
        background-color: ${colors.white};
        color: ${colors.navy};
      }
      
      &:focus-visible {
        background-color: ${colors.skip_yellow};
        color: ${colors.black};
        border: 2px solid ${colors.border_black};
        outline: none;
        text-decoration: underline;
        text-decoration-color: ${colors.black};
      }

      ${breakpoints.m} {
        width: 394px;
        background-color: none;
      }
    `,
  };
};
